module.exports = __webpack_public_path__ + "static/img/KEX (Pick Up).e201949.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/KEX (Pick Up).png
// module id = ypUD
// module chunks = 134